import { render, staticRenderFns } from "./ad-user-init-admin.vue?vue&type=template&id=eeba7b00&scoped=true&"
import script from "./ad-user-init-admin.vue?vue&type=script&lang=ts&"
export * from "./ad-user-init-admin.vue?vue&type=script&lang=ts&"
import style0 from "./ad-user-init-admin.vue?vue&type=style&index=0&id=eeba7b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeba7b00",
  null
  
)

export default component.exports